import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  PerformanceProcessTemplateBasicInfoFragment,
  PerformanceReviewerStrategiesStrategyEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ReviewerTypeSection } from 'modules/performance_process/components/review/forms/ReviewerType'
import { useUpdatePerformanceProcessTemplateReviewerStrategies } from 'modules/performance_process/hooks/useUpdatePerformanceProcessTemplateReviewerStrategies'

export const CustomTemplateSettingsReviewTypes: React.FC<{
  template: PerformanceProcessTemplateBasicInfoFragment
}> = ({ template }) => {
  const { updateReviewerStrategies, loading } =
    useUpdatePerformanceProcessTemplateReviewerStrategies()

  const handleReviewerStrategiesChange = (
    reviewerStrategies: PerformanceReviewerStrategiesStrategyEnum[]
  ) => {
    updateReviewerStrategies(template.id, reviewerStrategies)
  }

  return (
    <Box gap="s32">
      <Text size="400" color="grey1000" weight="semibold">
        {i18n.t('performance_process.reviews.launch_review_types')}
      </Text>
      <Text.Normal size="200">
        {i18n.t('performance_process.reviews.create.reviewer_type_explanation_new')}
      </Text.Normal>
      <ReviewerTypeSection
        reviewerStrategies={template.reviewerStrategies || []}
        disabled={loading}
        onChange={handleReviewerStrategiesChange}
      />
    </Box>
  )
}
